import { IOption } from '@gcl/react-core';

export const TransmittalStatusOptions: IOption<string>[] = [
  { key: 'APP', text: 'Approved' },
  { key: 'DRA', text: 'Draft' },
];

export const TransmittalFormTypesOptions: IOption<string>[] = [
  { key: 'DESIGNER', text: 'Designer' },
  { key: 'SITE', text: 'Site' },
  { key: 'ICE', text: 'Checker' },
  { key: 'LIR', text: 'Lambeth Independent Review' },
];
